/*
 * @Author: chenmin
 * @version: 1.0.0
 * @Date: 2022-10-31 10:21:15
 * @LastEditTime: 2022-11-07 16:38:08
 * @Description: 试卷api
 */

const API = `/api/v1`

// export const SHIJUAN_COLUMN_TYPE = `${API}/basic/manager/reBasicDetailType/column/{columnId}`;

export const SHIJUAN_COLUMN_TYPE_GET = `${API}/basic/manager/reBasicRelationColumnTypes`;
export const SHIJUAN_COLUMN_TYPE_SET = `${API}/basic/manager/reBasicRelationColumnType/add`;
export const SHIJUAN_COLUMN_TYPE_DEAL = `${API}/basic/manager/reBasicRelationColumnType/{id}/update/status/{used}`;

export const SHIJUAN_TYPE_MAP_GET = `${API}/basic/manager/reBasicPaperTypeMappings`;
export const SHIJUAN_TYPE_MAP_SET = `${API}/basic/manager/reBasicPaperTypeMapping/addOrUpdate`;



// WEBPACK FOOTER //
// ./src/resource/shijuan.js